import { render, staticRenderFns } from "./HelpDialog.vue?vue&type=template&id=01b6a865&scoped=true&"
import script from "./HelpDialog.vue?vue&type=script&lang=ts&"
export * from "./HelpDialog.vue?vue&type=script&lang=ts&"
import style0 from "./HelpDialog.vue?vue&type=style&index=0&id=01b6a865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6a865",
  null
  
)

export default component.exports